<div class="row" *ngIf="partnerParents.length > 0">
    <div class="col-lg-6">
        <h5>Franchise</h5>
        <p-listbox [options]="partnerParents" [(ngModel)]="selectedPartnerParentId" [listStyle]="{'max-height':'250px'}" [filter]="true" [filterFields]="['name']"
                   (onChange)="selectedFranchiseChange()">
            <ng-template let-partnerParent pTemplate="item">
                <div class="p-helper-clearfix">
                    <span style="margin:20px 10px 0 10px">{{partnerParent.name}}
                        ({{partnerParent.partnersLinked.length}})</span>
                </div>
            </ng-template>
            <p-footer>
                <div class="row">
                    <div class="col-lg-6" style="display:flex; align-items:center;">
                        Quick Actions
                    </div>
                    <div class="col-lg-6" style="display:flex; justify-content:flex-end;">
                        <p-button label="Add" [ngStyle]="{'margin-right' : '8px'}" (click)="newFranchise()"></p-button>
                        <p-button *ngIf="selectedPartnerParentId != null" label="Edit"
                                  (click)="editFranchise()"></p-button>
                    </div>
                </div>
            </p-footer>
        </p-listbox>
    </div>
    <div class="col-lg-6">
        <h5>Store(s)</h5>
        <p-listbox [options]="partners" [(ngModel)]="selectedPartnersIds" [listStyle]="{'max-height':'275px'}" [filter]="true" [filterFields]="['name']"
                   [multiple]="true" [checkbox]="false" [showToggleAll]="false" [disabled]="!selectedPartnerParentId">

            <!--      todo (dcorbett) removed  filter="contains" -->
            <ng-template let-partner pTemplate="item" style="display:flex !important">
                <div class="" style="display: inline; vertical-align: middle;">
                    <!--<img src="{{partner.imageFilename}}" style="display:inline-block;margin:0px 0 0 5px" width="24">-->
                    <span style="margin:20px 10px 0 10px">{{partner.value}} => {{partner.name}} ({{partner.status}})</span>
                </div>
            </ng-template>
            <p-footer>
                Selected: {{selectedPartnersIds?.length || '0'}}
            </p-footer>
        </p-listbox>
    </div>
</div>
<br/>
<div class="row" *ngIf="selectedPartnersIds?.length > 0 || selectedPartnerParentId">
    <div class="col-lg-12">
        <h5>Confirm this is what you want</h5>
        <p>You are going to assign the selected franchise to the selected store(s):</p>

        <ul>
            <ng-container *ngFor="let partner of partners">
                <ng-container *ngFor="let selected of selectedPartnersIds">
                    <li *ngIf="partner.id == selected">{{partner.name}}</li>
                </ng-container>
            </ng-container>
        </ul>
        <!--todo (dcrobett) removed   [disabled]="busy"  no busy-->
        <button pButton type="button" class="p-button-raised" (click)="franchiseLink()" label="Confirm"></button>

    </div>
</div>
<p-toast position="bottom-right" styleClass="hubtiger-toast"></p-toast>